import { atom, DefaultValue, selector } from "recoil"
import { ObjectValues } from "../../../util/utilTypes"


// constants
export const TIMER_OVERLAY_STATE = {
  START: "START",
  PAUSE: "PAUSE",
  STOP: "STOP"
} as const


export const TIMER_DIRECTION = {
  DOWN: 1,
  UP: 2
}

// Type Definition
export type TimerOverlayState = ObjectValues<typeof TIMER_OVERLAY_STATE>
export type TimerDirection = ObjectValues<typeof TIMER_DIRECTION>

type TimerOverlay = {
  usedDuration: number;
  allowedDuration: number;
  timerOverlayState: TimerOverlayState,
  timerDirection: TimerDirection,
}

type SetOverlayTimerSelectorType = {
  action: TimerOverlayState,
  payload: Omit<Partial<TimerOverlay>, "timerOverlayState">
}


// Atoms

// store timer overlay information
export const timerOverlayAtom = atom<TimerOverlay>({
  key: "timerOverlayAtom",
  default: {
    usedDuration: 0,
    allowedDuration: 0,
    timerDirection: TIMER_DIRECTION.DOWN,
    timerOverlayState: TIMER_OVERLAY_STATE.STOP
  }
})

export const showTimerOverlayAtom = atom({
  key: "showTimerOverlayAtom",
  default: false
})

export const timerOverlayCompletedTimeAtom = atom({
  key: "timerOverlayCompletedTimeAtom",
  default: 0
})

// Selectors

export const setOverlayTimerSelector = selector<SetOverlayTimerSelectorType>({
  key: "setOverlayTimerSelector",
  get: () => null,
  set: ({ set }, data ) => {
    if(data instanceof DefaultValue) return
    
    const { payload, action } = data

    // set current timer value state
    set(timerOverlayAtom, (prev) => ({
      ...prev,
      timerOverlayState: action,
      ...payload
    }))

    // perform action according to action
    switch(action) {
      case TIMER_OVERLAY_STATE.START: 
        set(showTimerOverlayAtom, true)
        break;
      case TIMER_OVERLAY_STATE.PAUSE:
        set(showTimerOverlayAtom, true)
        break
      case TIMER_OVERLAY_STATE.STOP:
        set(showTimerOverlayAtom, false)
        break
    }

    // set prev completed Time Atom
    set(timerOverlayCompletedTimeAtom, 0)
  }
})

export const resetOverlayTimerSelector = selector({
  key: "resetOverlayTimerSelector",
  get: () => {},
  set: ({ reset }) => {
    reset(timerOverlayAtom)
    reset(showTimerOverlayAtom)
    reset(timerOverlayCompletedTimeAtom)
  }
})

